import {observable, decorate } from 'mobx';
import { inputsBlocksObj } from '../configs/InputsBlocksConfig';
import InputsBlockStore from './InputsBlockStore.js';
class AllInputsBlockStore {
  inputsBlocks = {}


  constructor(store, obj) {
    this.loadBlocks();
  }


  loadBlocks() {
    for(let name in inputsBlocksObj) {
      const data = inputsBlocksObj[name];
      const block = this.createInputBlock(data);
      this.inputsBlocks[name] = block;
    }
  }

  createInputBlock(data) {
    const block = new InputsBlockStore(this, data);
    return block;
  }


};

decorate(AllInputsBlockStore, {
  inputsBlocks: observable,

});

export default AllInputsBlockStore;
